import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { apiService } from './api.service';
import { Structural } from '../types';

class StructuralOptionsService {
  async getAllStructuralOptions(status: string = STATUS_FILTER_VALUES.ALL): Promise<Structural[]> {
    try {
      const params = { [QUERY_PARAMS.STATUS]: status };
      return await apiService.get<Structural[]>(CR_API_ENDPOINTS.STRUCTURAL_OPTIONS, params);
    } catch (error) {
      throw new Error(`Failed to fetch structural options: ${error}`);
    }
  }

  async getFramingSizes(status: string = STATUS_FILTER_VALUES.ALL): Promise<Structural[]> {
    try {
      const params = { [QUERY_PARAMS.STATUS]: status };
      return await apiService.get<Structural[]>(CR_API_ENDPOINTS.STRUCTURAL_FRAMING_SIZES, params);
    } catch (error) {
      throw new Error(`Failed to fetch framing sizes: ${error}`);
    }
  }

  async getFramingTypes(status: string = STATUS_FILTER_VALUES.ALL): Promise<Structural[]> {
    try {
      const params = { [QUERY_PARAMS.STATUS]: status };
      return await apiService.get<Structural[]>(CR_API_ENDPOINTS.STRUCTURAL_FRAMING_TYPES, params);
    } catch (error) {
      throw new Error(`Failed to fetch framing types: ${error}`);
    }
  }

  async getRafterSpacings(status: string = STATUS_FILTER_VALUES.ALL): Promise<Structural[]> {
    try {
      const params = { [QUERY_PARAMS.STATUS]: status };
      return await apiService.get<Structural[]>(CR_API_ENDPOINTS.STRUCTURAL_RAFTER_SPACINGS, params);
    } catch (error) {
      throw new Error(`Failed to fetch rafter spacings: ${error}`);
    }
  }

  async getByCategory(category: string, status: string = STATUS_FILTER_VALUES.ALL): Promise<Structural[]> {
    try {
      const params = { category, [QUERY_PARAMS.STATUS]: status };
      return await apiService.get<Structural[]>(CR_API_ENDPOINTS.STRUCTURAL_OPTIONS, params);
    } catch (error) {
      throw new Error(`Failed to fetch structural options by category: ${error}`);
    }
  }

  async getStructuralOptionById(id: string): Promise<Structural> {
    try {
      return await apiService.get<Structural>(`${CR_API_ENDPOINTS.STRUCTURAL_OPTIONS}/${id}`);
    } catch (error) {
      throw new Error(`Failed to fetch structural option: ${error}`);
    }
  }

  async createStructural(structuralData: {
    category: string;
    value: string;
    displayOrder?: number;
  }): Promise<Structural> {
    try {
      return await apiService.post<Structural>(CR_API_ENDPOINTS.STRUCTURAL_OPTIONS, structuralData);
    } catch (error) {
      throw new Error(`Failed to create structural option: ${error}`);
    }
  }
}

export const structuralOptionsService = new StructuralOptionsService();